import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges Tailwind classes, resolving conflicts so a caller's `className` can
 * override a component's defaults instead of both classes landing in the DOM
 * and the winner being decided by stylesheet order.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
